export enum WeekendDisplay {
  None = 'none',
  Saturday = 'saturday',
  Full = 'full',
}